import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faBan } from '@fortawesome/free-solid-svg-icons';

const MembersTable = ({ member, selectMember }) => {
  const { 
    endpoint, 
    membername, 
    paused, 
    penalty, 
    queueName,
    queue_name,
    ringinuse, 
    stateInterface, 
    wrapuptime, 
    uniqueid,
    reasonPaused,
    memberorder
  } = member;

  const displayQueueName = (queueName !== null && queueName !== undefined && queueName !== '') 
    ? String(queueName).trim() 
    : (queue_name !== null && queue_name !== undefined && queue_name !== '') 
      ? String(queue_name).trim() 
      : '-';

  return (
    <tr>
      <td><input name="uniqueid" type="radio" onChange={() => selectMember(uniqueid)}></input></td>
      <td>{endpoint || '-'}</td>
      <td>{membername || '-'}</td>
      <td>{displayQueueName}</td>
      <td>{paused?'Sim':'Não'}</td>
      <td>{penalty !== null && penalty !== undefined ? penalty : '-'}</td>
      <td>{memberorder !== null && memberorder !== undefined ? memberorder : '-'}</td>
      <td>{ringinuse || '-'}</td>
      <td>{stateInterface || '-'}</td>
      <td>{wrapuptime !== null && wrapuptime !== undefined ? wrapuptime : '-'}</td>
    </tr>
  );
};

// MembersTable.propTypes = {
//     data: PropTypes.string,
//     origem_primaria: PropTypes.string,
//     origem_secundaria: PropTypes.string,
//     setor: PropTypes.string,
//     destino_secundario: PropTypes.string,
//     destino_primario: PropTypes.string,
//     status: PropTypes.string,
//     aguardando_atendimento: PropTypes.string,
//     duracao: PropTypes.string,
//     tipo: PropTypes.string,
//     id: PropTypes.string,
//     sequencia: PropTypes.number,
//     protocolo: PropTypes.string,
//   };

export default MembersTable;

